var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.753 17.78c-.977.136-2.25.136-3.959.136H9.211c-3.359 0-5.038 0-6.082-1.043-1.043-1.044-1.043-2.723-1.043-6.082V9.208c0-3.359 0-5.038 1.043-6.082 1.044-1.043 2.723-1.043 6.082-1.043h1.583c3.36 0 5.038 0 6.082 1.043 1.043 1.044 1.043 2.723 1.043 6.082v1.583c0 1.007 0 1.863-.028 2.596-.022.588-.034.881-.256.991-.223.11-.471-.066-.97-.418l-1.12-.794"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.452 10.329c-.147.522-.844.891-2.235 1.63-1.346.713-2.02 1.07-2.561.926a1.4 1.4 0 0 1-.593-.327c-.399-.375-.399-1.103-.399-2.558 0-1.456 0-2.184.399-2.559.164-.155.368-.267.593-.327.542-.143 1.215.214 2.56.927 1.393.738 2.089 1.107 2.236 1.63.06.215.06.442 0 .658Z"
  })));
};
export default SvgYoutube;